/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for progress.
 */
'use strict';

angular
  .module('services.progress', ['http.progress'])
  /**
   * Factory used to access polled progress data.  It will poll on a short interval when there is an
   * action currently in progress, and a longer polling interval when there are no current progresses
   * being reported.
   */
  .factory('progressFactory', function (httpProgress, $timeout, $rootScope, PROGRESS_ACTIONS) {
    let shortPause = 4000,
      longPause = 10000,
      poller,
      updateFromProgressItems,
      // Object used to hold progress data returned from the server.
      progress = {
        backupInProgress: false,
        exportInProgress: false,
        bulkRestoreInProgress: false,
        bulkRestorePreviewInProgress: false,
        bulkRestoreCsvVerificationInProgress: false,
        metadataCompareInProgress: false,
        metadataRestoreInProgress: false,
        gdprOperationInProgress: false,
        backup: {},
        exportObj: {},
        bulkRestoreObj: {},
        bulkRestorePreviewObj: {},
        bulkRestoreCsvVerificationObj: {},
        metadataCompareObj: {},
        metadataRestoreObj: {},
        gdprOperationObj: {},
        hideBackupProgress: false,
        hideExportProgress: false,
        hideBulkRestoreProgress: false,
        hideBulkRestorePreviewProgress: false,
        hideBulkRestoreCsvVerificationProgress: false,
        hideMetadataCompareProgress: false,
        hideMetadataRestoreProgress: false,
        disabled: false,
        minimized: false,
        /**
         * Function used to initialize watches on the progress var's.
         */
        initProgressWatches: function () {
          var self = this;

          $rootScope.$watch(
            function () {
              return self.backupInProgress;
            },
            function () {
              $rootScope.backupInProgress = self.backupInProgress;
              // If the backup is not in progress, clear the backup object so progress text and progress bar will reset for the next time its used.
              if (!self.backupInProgress) {
                self.clearBackupStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.exportInProgress;
            },
            function () {
              $rootScope.exportInProgress = self.exportInProgress;
              // If the export is not in progress, clear the export object so the progress text and progress bar will reset for the next time its used.
              if (!self.exportInProgress) {
                self.clearExportStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.bulkRestoreInProgress;
            },
            function () {
              $rootScope.bulkRestoreInProgress = self.bulkRestoreInProgress;
              // If the bulk restore is not in progress, clear the bulk restore object so the progress text and progress bar will reset for the next time its used.
              if (!self.bulkRestoreInProgress) {
                self.clearBulkRestoreStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.bulkRestorePreviewInProgress;
            },
            function () {
              $rootScope.bulkRestorePreviewInProgress = self.bulkRestorePreviewInProgress;
              // If the bulk restore preview is not in progress, clear the bulk restore preview object so the progress text and progress bar will reset for the next time its used.
              if (!self.bulkRestorePreviewInProgress) {
                self.clearBulkRestorePreviewStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.bulkRestoreCsvVerificationInProgress;
            },
            function () {
              $rootScope.bulkRestoreCsvVerificationInProgress = self.bulkRestoreCsvVerificationInProgress;
              // If the bulk restore csv verification is not in progress, clear the bulk restore preview object so the progress text and progress bar will reset for the next time its used.
              if (!self.bulkRestoreCsvVerificationInProgress) {
                self.clearBulkRestoreCsvVerificationStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.gdprOperationInProgress;
            },
            function () {
              $rootScope.gdprOperationInProgress = self.gdprOperationInProgress;
              // If the gdpr operation is not in progress, clear the gdpr operation object so the progress text and progress bar will reset for the next time its used.
              if (!self.gdprOperationInProgress) {
                self.clearGdprOperationStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.metadataCompareInProgress;
            },
            function () {
              $rootScope.metadataCompareInProgress = self.metadataCompareInProgress;
              // If the metadata compare is not in progress, clear the metadata compare object so the progress text and progress bar will reset for the next time its used.
              if (!self.metadataCompareInProgress) {
                self.clearMetadataCompareStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.metadataRestoreInProgress;
            },
            function () {
              $rootScope.metadataRestoreInProgress = self.metadataRestoreInProgress;
              // If the metadata restore is not in progress, clear the metadata restore object so the progress text and progress bar will reset for the next time its used.
              if (!self.metadataRestoreInProgress) {
                self.clearMetadataRestoreStatus();
              }
            }
          );

          $rootScope.$watch(
            function () {
              return self.backup;
            },
            function () {
              $rootScope.backupProgress = self.backup;
            }
          );

          $rootScope.$watch(
            function () {
              return self.exportObj;
            },
            function () {
              $rootScope.exportProgress = self.exportObj;
            }
          );

          $rootScope.$watch(
            function () {
              return self.bulkRestoreObj;
            },
            function () {
              $rootScope.bulkRestoreProgress = self.bulkRestoreObj;
            }
          );

          $rootScope.$watch(
            function () {
              return self.gdprOperationObj;
            },
            function () {
              $rootScope.gdprOperationProgress = self.gdprOperationObj;
            }
          );

          $rootScope.$watch(
            function () {
              return self.bulkRestorePreviewObj;
            },
            function () {
              $rootScope.bulkRestorePreviewProgress = self.bulkRestorePreviewObj;
            }
          );

          $rootScope.$watch(
            function () {
              return self.bulkRestoreCsvVerificationObj;
            },
            function () {
              $rootScope.bulkRestoreCsvVerificationProgress = self.bulkRestoreCsvVerificationObj;
            }
          );

          $rootScope.$watch(
            function () {
              return self.metadataCompareObj;
            },
            function () {
              $rootScope.metadataCompareProgress = self.metadataCompareObj;
            }
          );

          $rootScope.$watch(
            function () {
              return self.metadataRestoreObj;
            },
            function () {
              $rootScope.metadataRestoreProgress = self.metadataRestoreObj;
            }
          );
        },
        /**
         * Function used to disabled the progress poller and set the export, backup, and bulk restore status to an
         * empty value.
         */
        disableProgress: function () {
          this.disabled = true;
          this.backupInProgress = false;
          this.exportInProgress = false;
          this.bulkRestoreInProgress = false;
          this.bulkRestorePreviewInProgress = false;
          this.gdprOperationInProgress = false;
          this.metadataCompareInProgress = false;
          this.metadataRestoreInProgress = false;
          this.clearBackupStatus();
          this.clearExportStatus();
          this.clearBulkRestoreStatus();
          this.clearGdprOperationStatus();
          this.clearBulkRestorePreviewStatus();
          this.clearBulkRestoreCsvVerificationStatus();
          this.clearMetadataCompareStatus();
          this.clearMetadataRestoreStatus();
        },
        /**
         * Function used to set the backup status to an empty value.
         */
        clearBackupStatus: function () {
          this.backup = {};
        },
        /**
         * Function used to set the export status to an empty value.
         */
        clearExportStatus: function () {
          this.exportObj = {};
        },
        /**
         * Function used to set the bulk restore status to an empty value.
         */
        clearBulkRestoreStatus: function () {
          this.bulkRestoreObj = {};
        },
        /**
         * Function used to set the bulk restore preview status to an empty value.
         */
        clearBulkRestorePreviewStatus: function () {
          this.bulkRestorePreviewObj = {};
        },
        /**
         * Function used to set the bulk restore csv verification status to an empty value.
         */
        clearBulkRestoreCsvVerificationStatus: function () {
          this.bulkRestoreCsvVerificationObj = {};
        },
        /**
         * Function used to set the gdpr operation status to an empty value.
         */
        clearGdprOperationStatus: function () {
          this.gdprOperationObj = {};
        },
        /**
         * Function used to set the metadata compare status to an empty value.
         */
        clearMetadataCompareStatus: function () {
          this.metadataCompareObj = {};
        },
        /**
         * Function used to set the metadata restore status to an empty value.
         */
        clearMetadataRestoreStatus: function () {
          this.metadataRestoreObj = {};
        },
        /**
         * Function used to check if action is running.
         */
        actionInProgress: function () {
          return (
            this.backupInProgress ||
            this.exportInProgress ||
            this.bulkRestoreInProgress ||
            this.bulkRestorePreviewInProgress ||
            this.gdprOperationInProgress ||
            this.bulkRestoreCsvVerificationInProgress ||
            this.metadataCompareInProgress ||
            this.metadataRestoreInProgress
          );
        }
      };

    /**
     * Utility function for processing the progress data array returned by the server.
     * @param {Progress} progressList [] The array of progress items returned by the server.
     */
    updateFromProgressItems = function (progressList) {
      var backupFound = false,
        exportFound = false,
        bulkRestoreFound = false,
        bulkRestorePreviewFound = false,
        bulkRestoreCsvVerificationFound = false,
        metadataCompareFound = false,
        metadataRestoreFound = false,
        gdprOperationFound = false;

      if (angular.isArray(progressList)) {
        angular.forEach(progressList, function (pItem) {
          pItem.bookmark = JSON.parse(pItem.bookmark);
          pItem.running = true;
          if (pItem.action === PROGRESS_ACTIONS.MAINTENANCE) {
            $rootScope.maintenanceModeFlag = true;
          } else if (pItem.action === PROGRESS_ACTIONS.BACKUP) {
            angular.extend(progress.backup, pItem);
            backupFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.EXPORT) {
            angular.extend(progress.exportObj, pItem);
            exportFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.BULK_RESTORE) {
            angular.extend(progress.bulkRestoreObj, pItem);
            bulkRestoreFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.BULK_RESTORE_PREVIEW) {
            angular.extend(progress.bulkRestorePreviewObj, pItem);
            bulkRestorePreviewFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.BULK_RESTORE_CSV_VERIFICATION) {
            angular.extend(progress.bulkRestoreCsvVerificationObj, pItem);
            bulkRestoreCsvVerificationFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.METADATA_COMPARE) {
            angular.extend(progress.metadataCompareObj, pItem);
            metadataCompareFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.METADATA_RESTORE) {
            angular.extend(progress.metadataRestoreObj, pItem);
            metadataRestoreFound = true;
          } else if (pItem.action === PROGRESS_ACTIONS.GDPR) {
            angular.extend(progress.gdprOperationObj, pItem);
            gdprOperationFound = true;
          }
        });
      }

      // Save the update in the inProgress value for each type until after the type has been
      // processed.
      if (backupFound !== progress.backupInProgress) {
        progress.backupInProgress = backupFound;
      }

      if (exportFound !== progress.exportInProgress) {
        progress.exportInProgress = exportFound;
      }

      if (bulkRestoreFound !== progress.bulkRestoreInProgress) {
        progress.bulkRestoreInProgress = bulkRestoreFound;
      }

      if (bulkRestorePreviewFound !== progress.bulkRestorePreviewInProgress) {
        progress.bulkRestorePreviewInProgress = bulkRestorePreviewFound;
      }

      if (bulkRestoreCsvVerificationFound !== progress.bulkRestoreCsvVerificationInProgress) {
        progress.bulkRestoreCsvVerificationInProgress = bulkRestoreCsvVerificationFound;
      }

      if (metadataCompareFound !== progress.metadataCompareInProgress) {
        progress.metadataCompareInProgress = metadataCompareFound;
      }

      if (metadataRestoreFound !== progress.metadataRestoreInProgress) {
        progress.metadataRestoreInProgress = metadataRestoreFound;
      }

      if (gdprOperationFound !== progress.gdprOperationInProgress) {
        progress.gdprOperationInProgress = gdprOperationFound;
      }
    };

    // Define a poller function that will run continuously after this factory has been loaded.
    poller = function () {
      httpProgress.getProgress().then(
        function (progressList) {
          var pollTime;
          updateFromProgressItems(progressList);
          if (!progress.disabled) {
            if (progress.actionInProgress()) {
              pollTime = shortPause;
            } else {
              pollTime = longPause;
            }

            $timeout(poller, pollTime);
          } else {
            progress.disableProgress();
          }
        },
        function () {
          var pollTime;
          if (progress.actionInProgress()) {
            pollTime = shortPause;
          } else {
            pollTime = longPause;
          }
          $timeout(poller, pollTime);
        }
      );
    };

    poller();

    return progress;
  });
